<template>
  <!-- R2 通用的页头  author: zhangxiaofeng-->
  <div :class="['general-header', 'type--' + type, isWhite ? 'white' : '', {'page-home': ['/workbench/index', '/cfmcc/kanban'].includes($route.path)}]">
    <div class="subscribe-mask" v-show="showSubscribeMask"></div>
    <header-login v-on="$listeners" v-if="type === 'login'" :is-white="isWhite"></header-login>
    <header-board v-else-if="type === 'board'" :page-title="pageTitle"></header-board>
    <header-logged v-else-if="type === 'logged'" :user-info="userInfo"
                   :no-logo="noLogo"
                   :page-title="pageTitle"
                   :capacity="capacity"
                   :showAnimate="showAnimate"
                   :new-message="newMessage"
                   :new-upload="newUpload"
                   :new-feedback="newFeedback"
                   :refresh-index="refreshIndex"
                   @fetchPersonalStorageHandle="fetchPersonalStorageHandle"
                   @clickHandle="clickFun">
    </header-logged>
    <header-message v-else-if="type === 'message'" :page-title="pageTitle" @clickHandle="clickFun"></header-message>
    <header-privacy v-else-if="type === 'privacy'"></header-privacy>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .general-header{
    /* 登录页、下载页、会员中心页的页头 */
    &.type--login{
      position: fixed;
      left: 0;
      top: 0;
      height: 72px;
      width: 100%;
      z-index: 900;
      &.white{
        background-color: #fff;
        box-shadow:0px 3px 4px 0px rgba(33,37,48,0.1);
      }
    }

    /* 简单页面的页头 如: 获取管理员账号页面、跳转的中间页面 */
    &.type--board{
      background-color: #2079FA;
    }

    /* 登录之后的 主要的页头要是 */
    &.type--logged, &.type--message, &.type--privacy{
      height: 56px;
      width: 100%;
      position: relative;
      background-color: #233255;
      z-index: 2001;
      &.white{
        background-color: #fff;
        box-shadow:0px 2px 8px 0px rgba(0,0,0, 0.1);
      }
      &.page-home {
        background: #112346;
      }
    }
  }
</style>
<script>
import {mapState} from 'vuex'
import HeaderLogin from './HeaderLogin'
import HeaderBoard from './HeaderBoard'
import HeaderLogged from './HeaderLogged'
import HeaderMessage from './HeaderMessage'
import HeaderPrivacy from './HeaderPrivacy'
export default {
  name: 'HeaderGeneral',
  props: {
    type: {
      type: String,
      default: 'logged'
    },
    noLogo: {
      type: Boolean,
      default: false
    },
    isWhite: {
      type: Boolean,
      default: false
    },
    pageTitle: {
      type: String,
      default: ''
    },
    showAnimate: {
      type: Boolean,
      default: false
    },
    newMessage: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => {}
    },
    capacity: {
      type: Object,
      default: () => {}
    },
    // 历史上传 是否有新动态
    newUpload: {
      type: Number,
      default: 0 // 0: 无上传， 1：有工程上传， 2：有清单上传， 3：有组价上传
    },
    // 我的反馈 是否有新动态
    newFeedback: {
      type: Boolean,
      default: false
    },
    // 强制刷新header数据
    refreshIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      showSubscribeMask: state => state.showSubscribeMask
    })
  },
  methods: {
    // 鼠标移动到个人信息 下拉按钮上是  主动获取 员工空间容量
    fetchPersonalStorageHandle () {
      this.$emit('queryStorage')
    },
    //  1. header 里面的点击事件 冒泡
    clickFun (obj) {
      this.$emit('clickHandle', obj)
    }
  },
  components: {
    HeaderLogin,
    HeaderBoard,
    HeaderLogged,
    HeaderMessage,
    HeaderPrivacy
  }
}
</script>
